import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { FormGroup, Input } from "reactstrap";
import NumericInput from "../../shared/NumericInput";
import DateInput from "../../shared/DateInput";
import SelectInput from "../../shared/SelectInput";
import { MANDATORY_FIELD_TYPES } from "../../../utils/Constants";
import moment from "moment";
import { getDynamicCatalogue } from "../../../service/api";
import { ALERT_TYPES, GLOBAL_CONSTANTS } from "../../../utils/Constants";

const DinamicAccordionInput = (props) => {
  const [selectOptions, setSelectOptions] = useState([]);
  const [catalogueOptions, setCatalogueOptions] = useState([]);
  const [inputValue, setInputValue] = useState();
  const [inputError, setInputError] = useState();  

  const getCatalogue = async (url) => {
    const path = new URL(url).pathname;

    getDynamicCatalogue(props.accessToken, path)
      .then((result) => {
        // formateo el resultado en como lo precisa un select 
        const options = result?.data?.map((item) => {
          const idKey = Object.keys(item).find((key) => key.endsWith("Id"));
          const dscKey = Object.keys(item).find((key) => key.endsWith("Dsc"));
          if (!idKey || !dscKey) {            
            console.log('Error getting catalogue. Keys "Id" and "Dsc" not found.');
            
            return null;
          }

          return {
            value: item[idKey],
            label: item[dscKey],
          };
        })
        .filter(Boolean);

        if (options.length > 0){
          setCatalogueOptions(options);
        } else {
          props.onShowNotificationEventOut({
            message: "Error getting catalogue",
            type: ALERT_TYPES.error,
          })
        }
        
      })
    .catch((error) => {
      console.error("Error getting catalogue:", error);
    })
  }

  const handleMandatoryFieldChange = (event) => {
    const value = event.target.value;
    const name = props.mandatoryFieldConfig.fieldName;

    setInputValue(value);
    setInputError(null);

    props.onChangeEventOut({ name, value });
  };

  
  useEffect(() => {
    if (props.isShowInput) {
      if (
        props.mandatoryFieldConfig?.selectValues &&
        props.mandatoryFieldConfig?.selectValues.length > 0
      ) {
        const options = props.mandatoryFieldConfig?.selectValues?.split("|").map((option) => ({
          label: option,
          value: option,
        }));
        setSelectOptions(options);
      }

      if (props.mandatoryFieldConfig?.dataType == MANDATORY_FIELD_TYPES.date) {
        let dateValue = new Date().toISOString().split("T")[0];

        handleMandatoryFieldChange({ target: { value: dateValue } });
      }
      
      if (props.mandatoryFieldConfig?.dataType == MANDATORY_FIELD_TYPES.catalogue) {
        getCatalogue(props.mandatoryFieldConfig?.selectValues);
      }

    }
  }, [props.selectValueOptions, props.isShowInput]);

  useEffect(() => {
    setInputError(props.inputError);
  }, [props.inputError]);

  return (
    <>
      <FormGroup>
        <label>{props.mandatoryFieldConfig.fieldDsc}</label>
        {props.mandatoryFieldConfig.dataType == MANDATORY_FIELD_TYPES.string && (
          <Input
            name={props.mandatoryFieldConfig.fieldName}
            defaultValue={inputValue}
            onChange={handleMandatoryFieldChange}
            placeholder={`Enter a value`}
            className={inputError ? "required-input" : ""}
          />
        )}
        {props.mandatoryFieldConfig.dataType == MANDATORY_FIELD_TYPES.number && (
          <NumericInput
            name={props.mandatoryFieldConfig.fieldName}
            defaultValue={inputValue}
            onChange={handleMandatoryFieldChange}
            placeholder={`Enter a value`}
            textAlign="left"
            className={inputError ? "required-input" : ""}
          />
        )}
        {props.mandatoryFieldConfig.dataType == MANDATORY_FIELD_TYPES.date && (
          <DateInput
            name={props.mandatoryFieldConfig.fieldName}
            defaultValue={inputValue}
            onChangeEventOut={handleMandatoryFieldChange}
            classNameProp={inputError ? "required-input" : ""}
          />
        )}
        {props.mandatoryFieldConfig.dataType == MANDATORY_FIELD_TYPES.select && (
          <SelectInput
            name={props.mandatoryFieldConfig.fieldName}
            placeholder={`Select a value`}
            options={selectOptions}
            isMultiSelect={false}
            isSearchable={true}
            onChange={handleMandatoryFieldChange}
            defaultValueProp={inputValue}
            className={inputError ? "required-input" : ""}
          />
        )}
        {props.mandatoryFieldConfig.dataType == MANDATORY_FIELD_TYPES.catalogue && (
          <SelectInput
            name={props.mandatoryFieldConfig.fieldName}
            placeholder={`Select a value`}
            options={catalogueOptions}
            isMultiSelect={false}
            isSearchable={true}
            onChange={handleMandatoryFieldChange}
            defaultValueProp={inputValue}
            className={inputError ? "required-input" : ""}
          />    
        )}        

        {inputError && <p className="error-message">{inputError}</p>}
      </FormGroup>
    </>
  );
};

DinamicAccordionInput.propTypes = {
  mandatoryFieldConfig: PropTypes.object,
  isShowInput: PropTypes.bool,
  inputError: PropTypes.string,
  onChangeEventOut: PropTypes.func,
  accessToken: PropTypes.string,
  onShowNotificationEventOut: PropTypes.func,
};

export default DinamicAccordionInput;
